import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import { canUseDOM } from '@swf/core/utils';

import BannerNotification from '../../../components/BannerNotification/BannerNotification';

import { TXTWCL_XXBrandXX_is_not_supported_on__ELL } from './BrowserNotification.messages.json';

const BrowserNotification: React.FC = () => {
  let show = false;
  if (canUseDOM) {
    const { userAgent } = window.navigator;
    show = userAgent.includes('MSIE ') || userAgent.includes('Trident/');
  }

  return show ? (
    <BannerNotification position="top">
      <Translation tagName="p" {...TXTWCL_XXBrandXX_is_not_supported_on__ELL} />
    </BannerNotification>
  ) : null;
};

export default BrowserNotification;
